import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { OrderAdditionalServiceGdsServiceServiceType, TravellerFieldEnum } from '@websky/graphql';
import { CartService } from '../../Cart/types';
import ServiceSummaryDivider from '../components/ServiceSummaryDivider/ServiceSummaryDivider';
import CartItemOptionAdapter from '../../Cart/CartItemOptionAdapter/CartItemOptionAdapter';
import { capitalizeFirstLetter, getUserValue } from '../../utils';
var BusinessSummary = function (props) {
    var t = useTranslation('Checkout').t;
    var onDeleteHandler = function (serviceId, passengerId, segmentId) {
        var _a;
        (_a = props.onServiceDelete) === null || _a === void 0 ? void 0 : _a.call(props, CartService.BusinessLounge, {
            type: OrderAdditionalServiceGdsServiceServiceType.Vip,
            serviceId: serviceId,
            passengerId: passengerId,
            segmentId: segmentId
        });
    };
    var items = React.useMemo(function () {
        var options = [];
        props.travellers.forEach(function (traveller) {
            var lastName = getUserValue(traveller, TravellerFieldEnum.LastName);
            var firstName = getUserValue(traveller, TravellerFieldEnum.FirstName);
            var header = [lastName, firstName].map(capitalizeFirstLetter).join(' ');
            props.services.forEach(function (service) {
                var _a, _b, _c;
                var travellerService = (_c = (_b = (_a = traveller.services) === null || _a === void 0 ? void 0 : _a.gdsServices) === null || _b === void 0 ? void 0 : _b.services) === null || _c === void 0 ? void 0 : _c.find(function (gdsService) { return gdsService.serviceId === service.id; });
                if (travellerService) {
                    options.push({
                        header: header,
                        items: [
                            {
                                id: travellerService.serviceId,
                                name: t('Business lounge'),
                                price: service.price,
                                onDelete: function () {
                                    var _a;
                                    return onDeleteHandler(travellerService.serviceId, traveller.id, (_a = travellerService.segmentIds) === null || _a === void 0 ? void 0 : _a[0]);
                                }
                            }
                        ]
                    });
                }
            });
        });
        return options;
    }, [props.travellers, props.services]);
    var content = React.useMemo(function () {
        return (React.createElement(ServiceSummaryDivider, null, items.map(function (item, index) { return (React.createElement(CartItemOptionAdapter, { option: item, key: index })); })));
    }, [items]);
    return props.children(content);
};
export default BusinessSummary;
